import { Application } from 'store/api/types';

export const ADD_APPLICATION = 'applications/add';
export const UPDATE_APPLICATION = 'applications/update';
export const REMOVE_APPLICATION = 'applications/remove';
export const SET_ACTIVE_APPLICATION = 'applications/set_active';

export const applicationsReducer = (
  state: {
    applications: Application[];
    activeApplication?: Application;
  },
  action: { uuid?: string; application?: Application; type: string },
) => {
  switch (action.type) {
    case ADD_APPLICATION:
      if (!action.application) {
        throw new Error();
      }

      return {
        ...state,
        applications: [...state.applications, action.application],
      };
    case UPDATE_APPLICATION: {
      if (!action.application) {
        throw new Error();
      }

      const application = action.application as Application;

      return {
        ...state,
        applications: state.applications.map(a => (a.uuid === application.uuid ? application : a)),
      };
    }
    case SET_ACTIVE_APPLICATION:
      if (!action.uuid) {
        throw new Error();
      }

      return {
        ...state,
        activeApplication: state.applications.find(application => application.uuid === action.uuid),
      };
    case REMOVE_APPLICATION:
      if (!action.uuid) {
        throw new Error();
      }

      return {
        ...state,
        applications: state.applications.filter(application => action.uuid && application.uuid !== action.uuid),
      };
    default:
      throw new Error();
  }
};
